import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/chat/display/message-parts/files-and-images/files-and-images.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
